import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Panel, PANEL_SPACING_VARIANT_SECONDARY } from './Panel'
import { Toggle } from '../Toggle'
import { Collapsible } from '../Collapsible'
import tokens from '../../design/tokens'
import { Title, TITLE_VARIANT_M, TITLE_VARIANT_S } from '../Title'
import { HelpIcon } from '../HelpIcon'

export const PANEL_TOGGLE_TITLE_VARIANT_M = TITLE_VARIANT_M
export const PANEL_TOGGLE_TITLE_VARIANT_S = TITLE_VARIANT_S

const StyledTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const StyledTitleContainer = styled.div`
  display: flex;
  align-items: center;
`
const StyledTitle = styled(Title)`
  display: inline-block;
`
const StyledTitleBadge = styled.div`
  margin-left: 4px;
`
const StyledParagraph = styled.div`
  margin-top: 8px;
`

const StyledCollapsible = styled(Collapsible)`
  .e-collapsible__inner {
    padding-top: ${tokens.spacing.medium};
    padding-bottom: ${tokens.spacing.small};
  }
`

export const PanelToggle = ({
  title,
  titleTooltip,
  titleBadge,
  titleVariant,
  paragraph,
  children,
  className,
  onClick,
  disabled,
  checked,
  onChange,
  'data-mu-test': dataAttributeTest,
  margin
}) => {
  return (
    <Panel
      className={className}
      data-mu-test={dataAttributeTest}
      onClick={onClick}
      spacingVariant={PANEL_SPACING_VARIANT_SECONDARY}
      disabled={disabled}
      margin={margin}
    >
      <StyledTop>
        <StyledTitleContainer>
          <StyledTitle variant={titleVariant}>{title}</StyledTitle>
          {titleBadge && <StyledTitleBadge>{titleBadge}</StyledTitleBadge>}
          {titleTooltip && <HelpIcon text={titleTooltip} inline={false} />}
        </StyledTitleContainer>
        <Toggle
          data-mu-test={dataAttributeTest && `${dataAttributeTest}-toggle`}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
      </StyledTop>
      {paragraph && <StyledParagraph>{paragraph}</StyledParagraph>}
      {children && (
        <StyledCollapsible
          data-mu-test={dataAttributeTest && `${dataAttributeTest}-children`}
          collapsed={!checked}
        >
          {children}
        </StyledCollapsible>
      )}
    </Panel>
  )
}

PanelToggle.defaultProps = {
  titleVariant: PANEL_TOGGLE_TITLE_VARIANT_M,
  margin: `0 0 ${tokens.spacing.large} 0`
}

PanelToggle.propTypes = {
  title: PropTypes.string,
  titleTooltip: PropTypes.string,
  titleBadge: PropTypes.node,
  paragraph: PropTypes.node,
  titleVariant: PropTypes.oneOf([
    PANEL_TOGGLE_TITLE_VARIANT_M,
    PANEL_TOGGLE_TITLE_VARIANT_S
  ]),
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  'data-mu-test': PropTypes.string,
  margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}
